import { AwsS3SetupModal } from 'scenes/integrations/aws-s3/AwsS3SetupModal'
import { AzureBlobSetupModal } from 'scenes/integrations/azure-blob/AzureBlobSetupModal'
import { DatabricksSetupModal } from 'scenes/integrations/databricks/DatabricksSetupModal'
import { GitLabSetupModal } from 'scenes/integrations/gitlab/GitLabSetupModal'
import { GoogleCloudServiceAccountSetupModal } from 'scenes/integrations/google-cloud-service-account/GoogleCloudServiceAccountSetupModal'
import { PostgreSQLSetupModal } from 'scenes/integrations/postgresql/PostgreSQLSetupModal'
import { RedshiftSetupModal } from 'scenes/integrations/redshift/RedshiftSetupModal'
import { S3CompatibleSetupModal } from 'scenes/integrations/s3-compatible/S3CompatibleSetupModal'
import { SnowflakeSetupModal } from 'scenes/integrations/snowflake/SnowflakeSetupModal'
import { urls } from 'scenes/urls'

import { ChannelSetupModal } from 'products/workflows/frontend/Channels/ChannelSetupModal'

import { registerIntegrationSetup } from './integrationSetupRegistry'

registerIntegrationSetup({
    kind: ['google-pubsub', 'google-cloud-storage', 'firebase'],
    menuItem: ({ kind, uploadKey }) => ({
        label:
            kind === 'firebase'
                ? 'Upload Firebase service account .json key file'
                : 'Upload Google Cloud .json key file',
        onClick: () => uploadKey(kind),
    }),
})

registerIntegrationSetup({
    kind: 'email',
    menuItem: () => ({
        label: 'Configure new email sender domain',
        to: urls.workflows('channels'),
    }),
})

registerIntegrationSetup({
    kind: 'twilio',
    menuItem: ({ openModal }) => ({
        label: 'Configure new Twilio account',
        onClick: () => openModal('twilio'),
    }),
    SetupModal: ({ isOpen, integration, onComplete, onClose }) => (
        <ChannelSetupModal
            isOpen={isOpen}
            channelType="twilio"
            integration={integration}
            onClose={onClose}
            onComplete={onComplete}
        />
    ),
})

registerIntegrationSetup({
    kind: 'databricks',
    menuItem: ({ openModal }) => ({
        label: 'Configure new Databricks account',
        onClick: () => openModal('databricks'),
    }),
    SetupModal: ({ isOpen, integration, onComplete }) => (
        <DatabricksSetupModal isOpen={isOpen} integration={integration} onComplete={onComplete} />
    ),
})

registerIntegrationSetup({
    kind: 'postgresql',
    menuItem: ({ openModal }) => ({
        label: 'Configure new PostgreSQL connection',
        onClick: () => openModal('postgresql'),
    }),
    SetupModal: ({ isOpen, integration, onComplete }) => (
        <PostgreSQLSetupModal isOpen={isOpen} integration={integration} onComplete={onComplete} />
    ),
})

registerIntegrationSetup({
    kind: 'google-cloud-service-account',
    menuItem: ({ openModal }) => ({
        label: 'Configure new Google Cloud service account',
        onClick: () => openModal('google-cloud-service-account'),
    }),
    SetupModal: ({ isOpen, integration, onComplete }) => (
        <GoogleCloudServiceAccountSetupModal isOpen={isOpen} integration={integration} onComplete={onComplete} />
    ),
})

registerIntegrationSetup({
    kind: 'gitlab',
    menuItem: ({ openModal }) => ({
        label: 'Configure new GitLab account',
        onClick: () => openModal('gitlab'),
    }),
    SetupModal: ({ isOpen, onComplete }) => <GitLabSetupModal isOpen={isOpen} onComplete={onComplete} />,
})

registerIntegrationSetup({
    kind: 'azure-blob',
    menuItem: ({ openModal }) => ({
        label: 'Configure new Azure Blob Storage connection',
        onClick: () => openModal('azure-blob'),
    }),
    SetupModal: ({ isOpen, integration, onComplete }) => (
        <AzureBlobSetupModal isOpen={isOpen} integration={integration} onComplete={onComplete} />
    ),
})

registerIntegrationSetup({
    kind: 'aws-s3',
    menuItem: ({ openModal }) => ({
        label: 'Configure new AWS S3 connection',
        onClick: () => openModal('aws-s3'),
    }),
    SetupModal: ({ isOpen, integration, onComplete }) => (
        <AwsS3SetupModal isOpen={isOpen} integration={integration} onComplete={onComplete} />
    ),
})

registerIntegrationSetup({
    kind: 'aws-redshift',
    menuItem: ({ openModal }) => ({
        label: 'Configure new Redshift connection',
        onClick: () => openModal('aws-redshift'),
    }),
    SetupModal: ({ isOpen, integration, onComplete }) => (
        <RedshiftSetupModal isOpen={isOpen} integration={integration} onComplete={onComplete} />
    ),
})

registerIntegrationSetup({
    kind: 's3-compatible',
    menuItem: ({ openModal }) => ({
        label: 'Configure new S3-compatible storage connection',
        onClick: () => openModal('s3-compatible'),
    }),
    SetupModal: ({ isOpen, integration, onComplete }) => (
        <S3CompatibleSetupModal isOpen={isOpen} integration={integration} onComplete={onComplete} />
    ),
})

registerIntegrationSetup({
    kind: 'snowflake',
    menuItem: ({ openModal }) => ({
        label: 'Configure new Snowflake connection',
        onClick: () => openModal('snowflake'),
    }),
    SetupModal: ({ isOpen, integration, onComplete }) => (
        <SnowflakeSetupModal isOpen={isOpen} integration={integration} onComplete={onComplete} />
    ),
})
